/* eslint-disable */

/**
 * build event chain to check when quick is powered up
 */
klevu.coreEvent.build({
  name: 'setRemoteConfigQuick',
  fire () {
    /*
    if (
      !klevu.getSetting(klevu.settings, 'settings.localSettings', false) ||
      klevu.isUndefined(klevu.search.extraSearchBox) ||
      klevu.search.extraSearchBox.length == 0
    ) {
      return false
    }
    */
    if (
      !klevu.getSetting(klevu.settings, 'settings.localSettings', false) ||
      klevu.isUndefined(klevu.search.extraSearchBox)
    ) {
      return false
    }
    return true
  },
  maxCount: 500,
  delay: 0
})

/**
 * Add base quick search templates
 */
klevu.coreEvent.attach('setRemoteConfigQuick', {
  name: 'search-quick-templates',
  fire () {
    klevu.each(klevu.search.extraSearchBox, (key, box) => {
      box
        .getScope()
        .template.setTemplate(
          klevu.dom.helpers.getHTML('#klevuQuickTemplateBase'),
          'klevuTemplateBase',
          true
        )
      box
        .getScope()
        .template.setTemplate(
          klevu.dom.helpers.getHTML('#klevuQuickAutoSuggestions'),
          'klevuQuickAutoSuggestions',
          true
        )
      box
        .getScope()
        .template.setTemplate(
          klevu.dom.helpers.getHTML('#klevuQuickPageSuggestions'),
          'klevuQuickPageSuggestions',
          true
        )
      box
        .getScope()
        .template.setTemplate(
          klevu.dom.helpers.getHTML('#klevuQuickCategorySuggestions'),
          'klevuQuickCategorySuggestions',
          true
        )
      box
        .getScope()
        .template.setTemplate(
          klevu.dom.helpers.getHTML('#klevuQuickProducts'),
          'klevuQuickProducts',
          true
        )
      box
        .getScope()
        .template.setTemplate(
          klevu.dom.helpers.getHTML('#klevuQuickProductBlock'),
          'klevuQuickProductBlock',
          true
        )
      box
        .getScope()
        .template.setTemplate(
          klevu.dom.helpers.getHTML('#klevuQuickNoResultFound'),
          'klevuQuickNoResultFound',
          true
        )
    })
  }
})
// attach click out defocus
klevu.coreEvent.attach('setRemoteConfigQuick', {
  name: 'search-click-out',
  fire () {
    klevu.coreEvent.attach('buildSearch', {
      name: 'clickOutEvent',
      fire () {
        /*
        klevu.settings.chains.documentClick.add({
          name: 'hideOverlay',
          fire (data, scope) {
            if (klevu.search.active) {
              const fullPage = klevu.getSetting(
                klevu.search.active.getScope().settings,
                'settings.search.fullPageLayoutEnabled',
                true
              )
              if (!fullPage) {
                const target = klevu.getSetting(
                  klevu.search.active.getScope().settings,
                  'settings.search.searchBoxTarget'
                )
                target.style = 'display: none !important;'
              }
            }
          }
        })
        */
      }
    })
  }
})
// attach locale settings
klevu.coreEvent.attach('setRemoteConfigQuick', {
  name: 'search-quick-locale',
  fire () {
    // add translations
    const translatorQuick = klevu.search.quick.getScope().template.getTranslator()
    translatorQuick.addTranslation('Search', 'Search')
    translatorQuick.addTranslation('<b>%s</b> productList', '<b>%s</b> Products')
    translatorQuick.addTranslation('<b>%s</b> contentList', '<b>%s</b> Other results')
    translatorQuick.mergeToGlobal()

    // set currency
    const currencyQuick = klevu.search.quick.getScope().currency

    currencyQuick.setCurrencys({
      GBP: {
        string: '£',
        format: '%s%s',
        atEnd: false,
        precision: 2,
        thousands: ',',
        decimal: '.',
        grouping: 3
      },
      USD: {
        string: 'USD',
        atEnd: true
      },
      EUR: {
        string: 'EUR',
        format: '%s %s',
        atEnd: true
      }
    })
    currencyQuick.mergeToGlobal()
  }
})

// attach all klevu chains
klevu.coreEvent.attach('setRemoteConfigQuick', {
  name: 'search-quick-chains',
  fire () {
    klevu.each(klevu.search.extraSearchBox, (key, box) => {
      // get the global translations
      box
        .getScope()
        .template.getTranslator()
        .mergeFromGlobal()
      // get the global currency
      box
        .getScope()
        .template.getTranslator()
        .getCurrencyObject()
        .mergeFromGlobal()

      // what to do when you focus on a search
      box.getScope().chains.events.focus.add({
        name: 'displayOverlay',
        fire (data, scope) {
          const target = klevu.getSetting(scope.kScope.settings, 'settings.search.searchBoxTarget')
          target.style = 'display: block !important;'
        }
      })
      box.getScope().chains.events.focus.add({
        name: 'doSearch',
        fire (data, scope) {
          const chain = klevu.getObjectPath(scope.kScope, 'chains.actions.doSearch')

          if (!klevu.isUndefined(chain) && chain.list().length !== 0) {
            chain.setScope(scope.kElem)
            chain.setData(data)
            chain.fire()
          }
          scope.kScope.data = data
          if (data.context.preventDefault === true) return false
        }
      })

      // what will the request look for
      box.getScope().chains.request.build.add({
        name: 'addAutosugestions',
        fire (data, scope) {
          const parameterMap = klevu.getSetting(scope.kScope.settings, 'settings.search.map', false)
          const suggestion = klevu.extend(true, {}, parameterMap.suggestions)

          suggestion.id = 'autosuggestion'
          suggestion.query = data.context.term
          suggestion.typeOfRequest = 'AUTO_SUGGESTIONS'
          suggestion.limit = 10

          data.request.current.suggestions.push(suggestion)
          data.context.doSearch = true
        }
      })

      box.getScope().chains.request.build.add({
        name: 'addCategoryCompressed',
        fire (data, scope) {
          const parameterMap = klevu.getSetting(scope.kScope.settings, 'settings.search.map', false)

          const categoryCompressed = klevu.extend(true, {}, parameterMap.recordQuery)

          // setquery type
          categoryCompressed.id = 'categoryCompressed'
          categoryCompressed.typeOfRequest = 'SEARCH'
          categoryCompressed.settings.query.term = data.context.term
          categoryCompressed.settings.typeOfRecords = ['KLEVU_CATEGORY']
          categoryCompressed.settings.searchPrefs = ['searchCompoundsAsAndQuery']
          categoryCompressed.settings.fields = ['id', 'name', 'shortDesc', 'url', 'typeOfRecord']
          categoryCompressed.settings.limit = 10
          categoryCompressed.settings.sort = 'RELEVANCE'

          data.request.current.recordQueries.push(categoryCompressed)

          data.context.doSearch = true
        }
      })
      box.getScope().chains.request.build.add({
        name: 'addCmsCompressed',
        fire (data, scope) {
          const parameterMap = klevu.getSetting(scope.kScope.settings, 'settings.search.map', false)

          const cmsCompressed = klevu.extend(true, {}, parameterMap.recordQuery)

          // setquery type
          cmsCompressed.id = 'cmsCompressed'
          cmsCompressed.typeOfRequest = 'SEARCH'
          cmsCompressed.settings.query.term = data.context.term
          cmsCompressed.settings.typeOfRecords = ['KLEVU_CMS']
          cmsCompressed.settings.searchPrefs = ['searchCompoundsAsAndQuery']
          cmsCompressed.settings.fields = ['id', 'name', 'shortDesc', 'url', 'typeOfRecord']
          cmsCompressed.settings.limit = 10
          cmsCompressed.settings.sort = 'RELEVANCE'

          data.request.current.recordQueries.push(cmsCompressed)

          data.context.doSearch = true
        }
      })

      box.getScope().chains.request.build.add({
        name: 'addProductList',
        fire (data, scope) {
          const parameterMap = klevu.getSetting(scope.kScope.settings, 'settings.search.map', false)

          const productList = klevu.extend(true, {}, parameterMap.recordQuery)

          // setquery type
          productList.id = 'productList'
          productList.typeOfRequest = 'SEARCH'
          productList.settings.query.term = data.context.term
          productList.settings.typeOfRecords = ['KLEVU_PRODUCT']
          productList.settings.fallbackQueryId = 'productListFallback'
          productList.settings.limit = 9999
          productList.settings.searchPrefs = ['searchCompoundsAsAndQuery']
          productList.settings.sort = 'RELEVANCE'

          data.request.current.recordQueries.push(productList)

          data.context.doSearch = true
        }
      })
      box.getScope().chains.request.build.add({
        name: 'addProductListFallback',
        fire (data, scope) {
          const parameterMap = klevu.getSetting(scope.kScope.settings, 'settings.search.map', false)

          // setquery type
          const productListFallback = klevu.extend(true, {}, parameterMap.recordQuery)

          // setquery type
          productListFallback.id = 'productListFallback'
          productListFallback.typeOfRequest = 'SEARCH'
          productListFallback.isFallbackQuery = 'true'
          productListFallback.settings.query.term = '*'
          productListFallback.settings.typeOfRecords = ['KLEVU_PRODUCT']
          productListFallback.settings.searchPrefs = [
            'excludeDescription',
            'searchCompoundsAsAndQuery'
          ]
          productListFallback.settings.limit = 9999
          productListFallback.settings.sort = 'RELEVANCE'

          data.request.current.recordQueries.push(productListFallback)

          data.context.doSearch = true
        }
      })

      // where to render the responce
      box.getScope().chains.template.render.add({
        name: 'renderResponse',
        fire (data, scope) {
          if (data.context.isSuccess) {
            scope.kScope.template.setData(data.template)
            const targetBox = 'klevuTemplateBase'
            const element = scope.kScope.template.convertTemplate(
              scope.kScope.template.render(targetBox)
            )
            const target = klevu.getSetting(
              scope.kScope.settings,
              'settings.search.searchBoxTarget'
            )
            target.innerHTML = ''
            target.classList.add('klevuTarget')
            scope.kScope.element.kData = data.template
            scope.kScope.template.insertTemplate(target, element)
          }
        }
      })

      // where to position the templace
      box.getScope().chains.template.render.add({
        name: 'positionTemplate',
        fire (data, scope) {
          const target = klevu.getSetting(scope.kScope.settings, 'settings.search.searchBoxTarget')
          const positions = scope.kScope.element.getBoundingClientRect()
          klevu.dom.find('.klevuWrap', target)[0].style = `top:${positions.bottom}px;left: ${
            positions.right - 500 > 0 ? positions.right - 500 : 0
          }px;right: auto;`
        }
      })

      // overide form action
      box.getScope().element.kElem.form.action = klevu.getSetting(
        box.getScope().settings,
        'settings.url.landing',
        false
      )
    })
  }
})

/**
 * Klevu Analytics Utility
 */
;(function (klevu) {
  /**
   * Function to get term request option
   * @param {*} scope
   */
  function getTermOptions (scope, isExtended) {
    const analyticsTermOptions = {
      klevu_term: scope.data.context.termOriginal ? scope.data.context.termOriginal : '*',
      klevu_pageNumber: 'unknown',
      klevu_src: 'unknown',
      klevu_limit: 'unknown',
      klevu_sort: 'unknown',
      klevu_totalResults: 'unknown',
      klevu_typeOfQuery: 'unknown',
      filters: false
    }

    const currentSection = scope.data.context.section
    if (!currentSection) {
      return analyticsTermOptions
    }

    // TO-DO: Get cached data

    const reqQueries = scope.data.request.current.recordQueries
    if (reqQueries) {
      const reqQueryObj = reqQueries.filter(obj => {
        return obj.id == currentSection
      })[0]
      if (reqQueryObj) {
        analyticsTermOptions.klevu_limit = reqQueryObj.settings.limit
        analyticsTermOptions.klevu_sort = reqQueryObj.settings.sort
        analyticsTermOptions.klevu_src = `[[typeOfRecord:${reqQueryObj.settings.typeOfRecords[0]}]]`
      }
    }
    const resQueries = scope.data.response.current.queryResults
    if (resQueries) {
      const resQueryObj = resQueries.filter(obj => {
        return obj.id == currentSection
      })[0]
      if (resQueryObj) {
        analyticsTermOptions.klevu_totalResults = resQueryObj.meta.totalResultsFound
        analyticsTermOptions.klevu_typeOfQuery = resQueryObj.meta.typeOfSearch

        const productListLimit = resQueryObj.meta.noOfResults
        analyticsTermOptions.klevu_pageNumber =
          Math.ceil(resQueryObj.meta.offset / productListLimit) + 1

        if (isExtended) {
          let selectedFiltersStr = ' [['
          let isAnyFilterSelected = false
          klevu.each(resQueryObj.filters, (key, filter) => {
            if (filter.type == 'SLIDER') {
              if (filter.start != filter.min || filter.end != filter.max) {
                if (isAnyFilterSelected) {
                  selectedFiltersStr += ';;'
                }
                isAnyFilterSelected = true
                selectedFiltersStr += `${filter.key}:${filter.start} - ${filter.end}`
              }
            } else {
              klevu.each(filter.options, (key, option) => {
                if (option.selected) {
                  if (isAnyFilterSelected) {
                    selectedFiltersStr += ';;'
                  }
                  isAnyFilterSelected = true
                  selectedFiltersStr += `${filter.key}:${option.name}`
                }
              })
            }
          })
          selectedFiltersStr += ']]'
          if (isAnyFilterSelected) {
            analyticsTermOptions.filters = true
            analyticsTermOptions.klevu_term += selectedFiltersStr
          }
        }
      }
    }
    return analyticsTermOptions
  }

  /**
   * Function to get product details
   * @param {*} productId
   * @param {*} scope
   */
  function getProductDetailsFromId (productId, scope) {
    const dataListId = scope.data.context.section
    let product
    const results = scope.data.response.current.queryResults
    if (results) {
      const dataList = results.filter(obj => {
        return obj.id == dataListId
      })[0]
      if (dataList) {
        const records = dataList.records
        const matchedProduct = records.filter(prod => {
          return prod.id == productId
        })[0]
        if (matchedProduct) {
          product = matchedProduct
        }
      }
    }
    return product
  }

  /**
   * Function to get object details from URL and Name
   * @param {*} url
   * @param {*} name
   * @param {*} scope
   * @param {*} dataListId
   */
  function getDetailsFromURLAndName (url, name, scope, dataListId) {
    let category = {}
    const results = scope.data.response.current.queryResults
    if (results) {
      const categoryList = results.filter(obj => {
        return obj.id == dataListId
      })[0]
      if (categoryList) {
        const records = categoryList.records
        const matchedCategory = records.filter(cat => {
          return cat.name == name && cat.url == url
        })[0]
        if (matchedCategory) {
          category = matchedCategory
        }
      }
    }
    return category
  }

  /**
   * Function to store analytics event data
   * @param {*} eventOptions
   */
  function storeAnalyticsEvent (dictionary, element, eventOptions) {
    const autoSug = klevu.dictionary(dictionary)
    if (autoSug && eventOptions) {
      autoSug.setStorage('local')
      autoSug.mergeFromGlobal()

      let dataList = []
      let existingDataList = autoSug.getElement(element)
      if (existingDataList && existingDataList.length && existingDataList != element) {
        existingDataList = JSON.parse(existingDataList)
        if (existingDataList.length) {
          existingDataList.push(eventOptions)
          dataList = existingDataList
        }
      } else {
        dataList.push(eventOptions)
      }

      autoSug.addElement(element, JSON.stringify(dataList))
      autoSug.mergeToGlobal()
    }
  }

  /**
   * Function to register auto suggestion product click event
   * @param {*} scope
   * @param {*} className
   * @param {*} dictionary
   * @param {*} element
   */
  function registerAutoSuggestProductClickEvent (scope, className, dictionary, element) {
    const target = klevu.getSetting(scope.settings, 'settings.search.searchBoxTarget')
    klevu.each(klevu.dom.find('.trackProductClick', target), (key, value) => {
      klevu.event.attach(
        value,
        'click',
        event => {
          const productId = value.dataset.id
          const searchResultContainer = klevu.dom.find(className, target)[0]
          let dataSection
          if (searchResultContainer) {
            dataSection = searchResultContainer.dataset.section
          }
          if (!dataSection) {
            return
          }
          scope.data.context.section = dataSection
          if (productId) {
            const product = klevu.analyticsUtil.base.getProductDetailsFromId(productId, scope)
            if (product) {
              const termOptions = klevu.analyticsUtil.base.getTermOptions(scope)
              if (termOptions) {
                termOptions.klevu_keywords = termOptions.klevu_term
                termOptions.klevu_productId = product.id
                termOptions.klevu_productName = product.name
                termOptions.klevu_productUrl = product.url
                termOptions.klevu_src = `[[typeOfRecord:${
                  product.typeOfRecord
                };;template:quick-search]]`
                delete termOptions.klevu_term
                klevu.analyticsUtil.base.storeAnalyticsEvent(dictionary, element, termOptions)
              }
            }
          }
        },
        true
      )
    })
  }

  /**
   * Function to register search auto suggestion click event
   * @param {*} scope
   * @param {*} className
   */
  function registerAutoSuggestTermEvent (scope, className, dictionary, element) {
    const target = klevu.getSetting(scope.settings, 'settings.search.searchBoxTarget')
    klevu.each(klevu.dom.find(className, target), (key, value) => {
      klevu.each(klevu.dom.find('.klevu-track-click', value), (key, sugEle) => {
        klevu.event.attach(sugEle, 'click', event => {
          const searchResultContainer = klevu.dom.find('.klevuQuickSearchResults', target)[0]
          let dataSection
          if (searchResultContainer) {
            dataSection = searchResultContainer.dataset.section
          }
          if (!dataSection) {
            return
          }
          scope.data.context.section = dataSection
          const suggestionText = sugEle.dataset.content
          const termOptions = klevu.analyticsUtil.base.getTermOptions(scope, true)
          if (termOptions) {
            termOptions.klevu_originalTerm = termOptions.klevu_term
            termOptions.klevu_term = suggestionText
            termOptions.klevu_src = '[[template:ac-suggestions]]'
            klevu.analyticsUtil.base.storeAnalyticsEvent(dictionary, element, termOptions)
          }
        })
      })
    })
  }

  /**
   * Function to register auto-suggestion page click event
   * @param {*} scope
   * @param {*} className
   * @param {*} dataListId
   * @param {*} dictionary
   * @param {*} element
   */
  function registerAutoSuggestPageClickEvent (scope, className, dataListId, dictionary, element) {
    const target = klevu.getSetting(scope.settings, 'settings.search.searchBoxTarget')
    klevu.each(klevu.dom.find(className, target), (key, value) => {
      klevu.each(klevu.dom.find('.klevu-track-click', value), (key, catEle) => {
        klevu.event.attach(catEle, 'click', event => {
          const url = catEle.dataset.url
          const catName = catEle.dataset.name
          const category = klevu.analyticsUtil.base.getDetailsFromURLAndName(
            url,
            catName,
            scope,
            dataListId
          )
          const termOptions = klevu.analyticsUtil.base.getTermOptions(scope)
          if (termOptions) {
            termOptions.klevu_keywords = termOptions.klevu_term
            termOptions.klevu_productId = category.id
            termOptions.klevu_productName = category.name
            termOptions.klevu_productUrl = category.url
            termOptions.klevu_src = `[[typeOfRecord:${
              category.typeOfRecord
            };;template:quick-search]]`
            delete termOptions.klevu_term
            klevu.analyticsUtil.base.storeAnalyticsEvent(dictionary, element, termOptions)
          }
        })
      })
    })
  }

  /**
   * Function to add product click event on landing page
   * @param {*} scope
   * @param {*} dictionary
   * @param {*} element
   */
  function registerLandingProductClickEvent (scope, dictionary, element) {
    const target = klevu.getSetting(scope.settings, 'settings.search.searchBoxTarget')
    klevu.each(klevu.dom.find('.klevuProductClick', target), (key, value) => {
      klevu.event.attach(value, 'click', event => {
        const parent = klevu.dom.helpers.getClosest(value, '.klevuProduct')
        if (parent && parent != null) {
          const productId = parent.dataset.id
          if (productId) {
            const product = klevu.analyticsUtil.base.getProductDetailsFromId(productId, scope)
            if (product) {
              const termOptions = klevu.analyticsUtil.base.getTermOptions(scope)
              if (termOptions) {
                termOptions.klevu_keywords = termOptions.klevu_term
                termOptions.klevu_productId = product.id
                termOptions.klevu_productName = product.name
                termOptions.klevu_productUrl = product.url
                termOptions.klevu_src = `[[typeOfRecord:${product.typeOfRecord};;template:landing]]`
                delete termOptions.klevu_term
                klevu.analyticsUtil.base.storeAnalyticsEvent(dictionary, element, termOptions)
              }
            }
          }
        }
      })
    })
  }

  /**
   * Function to send term analytics request from local storage
   * @param {*} dictionary
   * @param {*} element
   */
  function sendAnalyticsEventsFromStorage (dictionary, element) {
    const autoSug = klevu.dictionary(dictionary)
    autoSug.setStorage('local')
    autoSug.mergeFromGlobal()
    let storedEvents = autoSug.getElement(element)
    if (storedEvents && storedEvents != element) {
      storedEvents = JSON.parse(storedEvents)
      klevu.each(storedEvents, (index, value) => {
        delete value.filters
        if (element == klevu.analyticsUtil.base.storage.click) {
          klevu.analyticsEvents.click(value)
        } else if (element == klevu.analyticsUtil.base.storage.buy) {
          klevu.analyticsEvents.buy(value)
        } else if (element == klevu.analyticsUtil.base.storage.categoryClick) {
          // TO-DO: Send category product click event
          //console.log(value)
        } else {
          klevu.analyticsEvents.term(value)
        }
      })
      autoSug.addElement(element, '')
      autoSug.mergeToGlobal()
    }
  }

  /**
   * Function to get Category view options
   * @param {*} scope
   */
  function getCategoryViewOptions (scope) {
    const analyticsCategoryOptions = {
      klevu_categoryName: 'unknown',
      klevu_src: 'unknown',
      klevu_categoryPath: 'unknown',
      klevu_productIds: 'unknown',
      klevu_pageStartsFrom: 'unknown',
      filters: false
    }

    const currentSection = scope.data.context.section
    if (!currentSection) {
      return analyticsCategoryOptions
    }

    // TO-DO: Get cached data

    const reqQueries = scope.data.request.current.recordQueries
    if (reqQueries) {
      const reqQueryObj = reqQueries.filter(obj => {
        return obj.id == currentSection
      })[0]
      if (reqQueryObj) {
        if (reqQueryObj.settings.query && reqQueryObj.settings.query.categoryPath) {
          analyticsCategoryOptions.klevu_categoryName = reqQueryObj.settings.query.categoryPath
        }
        analyticsCategoryOptions.klevu_limit = reqQueryObj.settings.limit
        analyticsCategoryOptions.klevu_sort = reqQueryObj.settings.sort
        analyticsCategoryOptions.klevu_src = `[[typeOfRecord:${
          reqQueryObj.settings.typeOfRecords[0]
        }]]`
      }
    }

    const resQueries = scope.data.response.current.queryResults
    if (resQueries) {
      const resQueryObj = resQueries.filter(obj => {
        return obj.id == currentSection
      })[0]
      if (resQueryObj) {
        analyticsCategoryOptions.klevu_pageStartsFrom = resQueryObj.meta.offset
        if (resQueryObj.records && resQueryObj.records.length) {
          analyticsCategoryOptions.klevu_productIds = ''
          klevu.each(resQueryObj.records, (key, value) => {
            if (
              analyticsCategoryOptions.klevu_productIds &&
              analyticsCategoryOptions.klevu_productIds !== 'unknown'
            ) {
              if (value.id) {
                analyticsCategoryOptions.klevu_productIds += ','
              }
            }
            if (value.id) {
              analyticsCategoryOptions.klevu_productIds += value.id
            }
          })
          if (resQueryObj.records[0].klevu_category) {
            analyticsCategoryOptions.klevu_categoryPath = resQueryObj.records[0].klevu_category
          }
        }
      }
    }

    return analyticsCategoryOptions
  }

  /**
   * Function to register category product click event analytics
   * @param {*} scope
   * @param {*} dictionary
   * @param {*} element
   */
  function registerCategoryProductClickEvent (scope, dictionary, element) {
    const target = klevu.getSetting(scope.settings, 'settings.search.searchBoxTarget')
    klevu.each(klevu.dom.find('.klevuProductClick', target), (key, value) => {
      klevu.event.attach(value, 'click', event => {
        const parent = klevu.dom.helpers.getClosest(value, '.klevuProduct')
        if (parent && parent != null) {
          const productId = parent.dataset.id
          if (productId) {
            const product = klevu.analyticsUtil.base.getProductDetailsFromId(productId, scope)
            if (product) {
              const categoryOptions = klevu.analyticsUtil.base.getCategoryViewOptions(scope)
              categoryOptions.klevu_productId = product.id
              categoryOptions.klevu_productName = product.name
              categoryOptions.klevu_productUrl = product.url
              categoryOptions.klevu_src = `[[typeOfRecord:${
                product.typeOfRecord
              };;template:category]]`
              categoryOptions.klevu_productSku = product.sku
              categoryOptions.klevu_salePrice = product.salePrice
              categoryOptions.klevu_productRatings = product.rating
              categoryOptions.klevu_productPosition = categoryOptions.klevu_pageStartsFrom

              delete categoryOptions.klevu_term
              delete categoryOptions.klevu_pageStartsFrom

              klevu.analyticsUtil.base.storeAnalyticsEvent(dictionary, element, categoryOptions)
            }
          }
        }
      })
    })
  }

  const storageOptions = {
    dictionary: 'analytics-util',
    term: 'termList',
    click: 'clickList',
    categoryClick: 'categoryClickList',
    buy: 'buyList'
  }

  klevu.extend({
    analyticsUtil: {
      base: {
        storage: storageOptions,
        getTermOptions,
        getProductDetailsFromId,
        getDetailsFromURLAndName,
        storeAnalyticsEvent,
        registerAutoSuggestProductClickEvent,
        registerAutoSuggestTermEvent,
        registerAutoSuggestPageClickEvent,
        registerLandingProductClickEvent,
        sendAnalyticsEventsFromStorage,
        getCategoryViewOptions,
        registerCategoryProductClickEvent
      }
    }
  })

  klevu.analyticsUtil.build = true
})(klevu)

/**
 * Analytics Event build
 */
klevu.coreEvent.build({
  name: 'analyticsPowerUp',
  fire () {
    if (
      !klevu.getSetting(klevu.settings, 'settings.localSettings', false) ||
      !klevu.analytics.build ||
      !klevu.analyticsUtil.build
    ) {
      return false
    }
    return true
  },
  maxCount: 500,
  delay: 0
})

/**
 * Event to send request from queue
 */
klevu.coreEvent.attach('analyticsPowerUp', {
  name: 'attachSendRequestEvent',
  fire () {
    klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(
      klevu.analyticsUtil.base.storage.dictionary,
      klevu.analyticsUtil.base.storage.term
    )

    klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(
      klevu.analyticsUtil.base.storage.dictionary,
      klevu.analyticsUtil.base.storage.click
    )

    klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(
      klevu.analyticsUtil.base.storage.dictionary,
      klevu.analyticsUtil.base.storage.categoryClick
    )

    klevu.analyticsUtil.base.sendAnalyticsEventsFromStorage(
      klevu.analyticsUtil.base.storage.dictionary,
      klevu.analyticsUtil.base.storage.buy
    )
  }
})

/**
 * Attach core event to add quick search analytics
 */

klevu.coreEvent.attach('setRemoteConfigQuick', {
  name: 'attachQuickSearchAnalyticsEvents',
  fire () {
    klevu.each(klevu.search.extraSearchBox, (key, box) => {
      box.getScope().element.kScope.analyticsReqTimeOut = null

      /**
       * Send term request for analytics
       */
      box.getScope().chains.template.events.add({
        name: 'doAnalytics',
        fire (data, scope) {
          if (box.getScope().element.kScope.analyticsReqTimeOut) {
            clearTimeout(box.getScope().element.kScope.analyticsReqTimeOut)
          }
          const target = klevu.getSetting(scope.kScope.settings, 'settings.search.searchBoxTarget')
          const searchResultContainer = klevu.dom.find('.klevuQuickSearchResults', target)[0]
          let dataSection
          if (searchResultContainer) {
            dataSection = searchResultContainer.dataset.section
          }
          if (!dataSection) {
            return
          }
          scope.kScope.data.context.section = dataSection
          box.getScope().element.kScope.analyticsReqTimeOut = setTimeout(() => {
            const termOptions = klevu.analyticsUtil.base.getTermOptions(
              box.getScope().element.kScope,
              true
            )
            if (termOptions) {
              termOptions.klevu_src = termOptions.klevu_src.replace(
                ']]',
                ';;template:quick-search]]'
              )
              klevu.analyticsEvents.term(termOptions)
            }
            box.getScope().element.kScope.analyticsReqTimeOut = null
          }, 300)
        }
      })

      /**
       * Function to add result product click analytics
       */
      box.getScope().chains.template.events.add({
        name: 'doResultProductsAnalytics',
        fire (data, scope) {
          /**
           * Event to fire on quick search product click
           */

          klevu.analyticsUtil.base.registerAutoSuggestTermEvent(
            scope.kScope,
            '.klevuAutosuggestions',
            klevu.analyticsUtil.base.storage.dictionary,
            klevu.analyticsUtil.base.storage.term
          )

          klevu.analyticsUtil.base.registerAutoSuggestPageClickEvent(
            scope.kScope,
            '.klevuCmsSuggestions',
            'cmsCompressed',
            klevu.analyticsUtil.base.storage.dictionary,
            klevu.analyticsUtil.base.storage.click
          )

          klevu.analyticsUtil.base.registerAutoSuggestPageClickEvent(
            scope.kScope,
            '.klevuCategorySuggestions',
            'categoryCompressed',
            klevu.analyticsUtil.base.storage.dictionary,
            klevu.analyticsUtil.base.storage.click
          )

          klevu.analyticsUtil.base.registerAutoSuggestProductClickEvent(
            scope.kScope,
            '.klevuQuickSearchResults',
            klevu.analyticsUtil.base.storage.dictionary,
            klevu.analyticsUtil.base.storage.click
          )
        }
      })
    })
  }
})

/* eslint-enable */
